import { Enum } from "@/service/supplier-meta/entity/Enum";
import { sourceTypeEnum } from "@/service/supplier-meta/enums/sourceTypeEnum";
import { supplyClassificationEnum } from "@/service/supplier-meta/enums/supplyClassificationEnum";
import { paymentTypeEnum } from "@/service/supplier-meta/enums/paymentTypeEnum";
// import { supplyTypeEnum } from "@/service/supplier-meta/enums/supplyTypeEnum";
enum pendingEnums {
  规模类型 = "ScaleTypeEnum",
  付款类型 = "PaymentTypeEnum",
  供货分类 = "SupplyClassificationEnum",
  供应链类型 = "SupplyTypeEnum",
}
/**
 * 处理枚举差异
 */

export function resolveEnum(
  name: string,
  enums: Enum[],
  sourceType: number
): Enum[] {
  let res: Enum[] = [...enums];
  switch (sourceType) {
    /** 工厂 */
    case sourceTypeEnum.pmc_factory:
      if (name === pendingEnums.规模类型) {
        !res.some((e) => e.code === -1) &&
          res.unshift({
            desc: "请选择",
            code: -1,
          });
      } else if (name === pendingEnums.付款类型) {
        !res.some((e) => e.code === 0) &&
          res.unshift({
            desc: "请选择",
            code: 0,
          });
      } else if (name === pendingEnums.付款类型) {
        !res.some((e) => e.code === 0) &&
          res.unshift({
            desc: "请选择",
            code: 0,
          });
      }
      break;
    /** 面辅料 */
    case sourceTypeEnum.pmc_supplier:
      if (name === pendingEnums.规模类型) {
        !res.some((e) => e.code === -1) &&
          res.unshift({
            desc: "请选择",
            code: -1,
          });
      } else if (name === pendingEnums.供货分类) {
        res = res.filter((r) => r.code !== supplyClassificationEnum.成衣);
      } else if (name === pendingEnums.付款类型) {
        res = res.filter((r) =>
          [
            paymentTypeEnum.普通账期,
            paymentTypeEnum.转账发货,
            paymentTypeEnum.网拍,
          ].includes(+r.code)
        );
      }
      break;
    /** oa */
    case sourceTypeEnum.oa:
      if (name === pendingEnums.付款类型) {
        !res.some((e) => e.code === 0) &&
          res.unshift({
            desc: "请选择",
            code: 0,
          });
      } else if (name === pendingEnums.供货分类) {
        res = res.filter((r) => r.code === supplyClassificationEnum.成衣);
      }
      break;
  }
  return res;
}

export function isEnumValueNull(
  val: number,
  enumName: string,
  sourceType: number
): boolean {
  if (
    enumName === pendingEnums.付款类型 &&
    [sourceTypeEnum.oa, sourceTypeEnum.pmc_factory].includes(sourceType)
  ) {
    return val === 0;
  }
  if (sourceType === sourceTypeEnum.pmc_factory) {
    if (enumName === pendingEnums.规模类型) {
      return val === -1;
    }
  }
  return false;
}
